import { useEffect, useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'

import { BuilderDraggableElement, BuilderPage } from '@makyoapp/makyo-common'
import { cn, MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useAppPagesContext } from '@/context/AppPagesContext'
import { LeadingSidebarTab } from '@/shared/builder-ui'
import { EVENT_KEYS } from '@/shared/custom-event'

import { BuilderComponentCore, BuilderComponentCoreProps } from '../../__project__/BuilderComponentCore'

interface BuilderComponentProps extends BuilderComponentCoreProps {
  activePage?: BuilderPage
}

// /**
//  * Wrapper component that adds drag-and-drop functionality
//  *
//  * @mode appMode = 'preview' (builder) only
//  *
//  * @todo handle drag n drop from editor into app preview
//  */
// export const BuilderComponent = (props: BuilderComponentProps) => {
//   const { isDevelopmentMode, setActiveTab, setActiveComponent, activeLayer } = useAppBuilderContext()
//   const { activePageIndex, updatePageAlt } = useAppPagesContext()
//   const ref = useRef<HTMLDivElement>(null)

//   useEffect(() => {
//     if (!isDevelopmentMode) return
//     const handleOpenComponentSettings = (e: Event) => {
//       const { id, compId, groupId } = (e as CustomEvent).detail
//       setActiveTab(LeadingSidebarTab.Component)
//       setActiveComponent({ layerType: activeLayer.type, id, compId, groupId })
//     }
//     window.addEventListener(EVENT_KEYS.COMP_OPEN_SETTINGS, handleOpenComponentSettings)
//     return () => {
//       window.removeEventListener(EVENT_KEYS.COMP_OPEN_SETTINGS, handleOpenComponentSettings)
//     }
//   }, [activeLayer.type, isDevelopmentMode, setActiveComponent, setActiveTab])

//   // const [{ handlerId }, drop] = useDrop({
//   //   accept: 'component',
//   //   hover: async (item: BuilderDraggableElement, monitor) => {
//   //     if (!ref.current) {
//   //       return
//   //     }

//   //     if (!monitor.isOver({ shallow: true })) {
//   //       return
//   //     }

//   //     if (!monitor.canDrop()) {
//   //       return
//   //     }

//   //     const dragIndex = item.index

//   //     if (dragIndex === props.index) {
//   //       return
//   //     }

//   //     item.index = props.index
//   //   },
//   //   drop: () => {
//   //     //
//   //   },
//   //   collect: (monitor) => ({
//   //     name: 'component-card-droppable',
//   //     handlerId: monitor.getHandlerId(),
//   //     isOver: monitor.isOver(),
//   //     isOverCurrent: monitor.isOver({ shallow: true }),
//   //   }),
//   // })

//   // const [{ isDragging }, drag] = useDrag({
//   //   type: 'component',
//   //   item: {
//   //     ...props.element,
//   //     index: props.index,
//   //   },
//   //   collect: (monitor) => ({
//   //     isDragging: monitor.getItem()?.id === props.element.id,
//   //   }),
//   // })

//   // drag(drop(ref))

//   // Drag functionality - hanya untuk komponen yang bukan FAB
//   const [{ isDragging }, drag] = useDrag({
//     type: 'reorder-component',
//     item: {
//       ...props.element,
//       index: props.index,
//     },
//     canDrag: props.element.compId !== 'fab',
//     collect: (monitor) => ({
//       isDragging: monitor.getItem()?.id === props.element.id,
//     }),
//   })

//   // Drop functionality dengan debug
//   const [{ isOver, canDrop, handlerId }, drop] = useDrop({
//     accept: 'reorder-component',
//     canDrop: (item: BuilderDraggableElement) => {
//       if (item.id === props.element.id) return false
//       if (item.compId === 'fab') return false
//       if (item.compId === 'tab-item' && props.element.compId !== 'tabs') return false
//       return true
//     },
//     drop: (item: BuilderDraggableElement, monitor) => {
//       const shallow = monitor.isOver({ shallow: true })
//       const can = monitor.canDrop()
//       const did = monitor.didDrop?.()
//       console.log('[DROP]', { shallow, can, did, targetId: props.element.id, itemId: item.id })

//       if (!shallow || !can) return

//       // if (!monitor.isOver({ shallow: true })) return

//       const currentElements = props.activePage?.elements || []
//       const dragIndex = currentElements.findIndex((el) => el.id === item.id)
//       const dropIndex = currentElements.findIndex((el) => el.id === props.element.id)

//       console.log('[DROP] indices', { dragIndex, dropIndex, len: currentElements.length })
//       if (dragIndex === -1 || dropIndex === -1 || dragIndex === dropIndex) return

//       const newElements = [...currentElements]
//       const [draggedItem] = newElements.splice(dragIndex, 1)
//       newElements.splice(dropIndex, 0, draggedItem)

//       console.table({
//         before: currentElements.map((el) => el.id).join(' -> '),
//         after: newElements.map((el) => el.id).join(' -> '),
//       })

//       updatePageAlt(activePageIndex, (prev) => {
//         prev.elements = newElements
//       })
//     },
//     collect: (monitor) => ({
//       handlerId: monitor.getHandlerId(),
//       isOver: monitor.isOver(),
//       isOverCurrent: monitor.isOver({ shallow: true }),
//       canDrop: monitor.canDrop(),
//     }),
//   })

//   drag(drop(ref))

//   return (
//     <div className='relative group' ref={drag(drop(ref)) as any}>
//       <BuilderComponentCore
//         {...props}
//         ref={ref}
//         className={cn(
//           isDragging && 'opacity-50',
//           isDragging ? 'cursor-grabbing' : 'cursor-grab',
//           isOver && canDrop && 'border-2 border-blue-500 bg-blue-50',
//           isOver && !canDrop && 'border-2 border-red-500 bg-red-50',
//           props.element.compId === 'fab' && 'cursor-default'
//         )}
//       />
//     </div>
//   )
// }

export const BuilderComponent = (props: BuilderComponentCoreProps) => {
  const { setActiveTab, setActiveComponent, activeLayer } = useAppBuilderContext()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleOpenComponentSettings = (e: Event) => {
      const { id, compId, groupId } = (e as CustomEvent).detail
      setActiveTab(LeadingSidebarTab.Component)
      setActiveComponent({ layerType: activeLayer.type, id, compId, groupId })
    }
    window.addEventListener(EVENT_KEYS.COMP_OPEN_SETTINGS, handleOpenComponentSettings)
    return () => {
      window.removeEventListener(EVENT_KEYS.COMP_OPEN_SETTINGS, handleOpenComponentSettings)
    }
  }, [activeLayer.type, setActiveComponent, setActiveTab])

  // const [{ handlerId }, drop] = useDrop({
  //   accept: 'component',
  //   hover: async (item: BuilderDraggableElement, monitor) => {
  //     if (!ref.current) {
  //       return
  //     }

  //     if (!monitor.isOver({ shallow: true })) {
  //       return
  //     }

  //     if (!monitor.canDrop()) {
  //       return
  //     }

  //     const dragIndex = item.index

  //     if (dragIndex === props.index) {
  //       return
  //     }

  //     item.index = props.index
  //   },
  //   drop: () => {
  //     //
  //   },
  //   collect: (monitor) => ({
  //     name: 'component-card-droppable',
  //     handlerId: monitor.getHandlerId(),
  //     isOver: monitor.isOver(),
  //     isOverCurrent: monitor.isOver({ shallow: true }),
  //   }),
  // })

  // const [{ isDragging }, drag] = useDrag({
  //   type: 'component',
  //   item: {
  //     ...props.element,
  //     index: props.index,
  //   },
  //   collect: (monitor) => ({
  //     isDragging: monitor.getItem()?.id === props.element.id,
  //   }),
  // })

  // drag(drop(ref))

  return (
    <BuilderComponentCore
      {...props}
      ref={ref}
      // className={clsx(isDragging && 'bg-red-300', isDragging ? 'cursor-grabbing' : 'cursor-grab')}
    />
  )
}
